const config = {
    // Production 
    endpoint: "https://backend.bmc.ourcodelab.com",
    local_url: "https://bmc.ourcodelab.com",
    endpoint_1: "https://backend.bmc.ourcodelab.com",
    grapejs_sdk_key: "63c48a0b499a4583a76da871683f4dfc199ebd76c6be44b9bac834ed4bb624af",

    // Staging
    // endpoint: "https://backend.staging.bmc.ourcodelab.com",
    // local_url: "https://staging.bmc.ourcodelab.com",
    // endpoint_1: "https://backend.staging.bmc.ourcodelab.com",
    // grapejs_sdk_key: "deef27397a9549ad99fe2320580b5733b486e824bb90464791c5021c5a76fdc7",
    
    // Development
    // endpoint_1: "http://127.0.0.1:4000",
    // endpoint: "http://127.0.0.1:4000",
    // grapejs_sdk_key: "deef27397a9549ad99fe2320580b5733b486e824bb90464791c5021c5a76fdc7",

    /**
     * Endpoint_1 is for the globe
     */

    // endpoint_1: "http://192.168.1.89:4000",
    // endpoint_1: "http://192.168.1.35:4000",
    version: "1.3.2 (020226)",
    developer: "OurCodeLab LLP",
    support_email: "support@ourcodelab.com",
    project_name: "BMC plus",
    project_management_url: "https://projects.ourcodelab.com",
    support_phone: "+65 8356 1300",
    website: "https://ourcodelab.com",

    client_name: "Bedok Methodist Church",
    client_app: "BMC plus",

    feature_flag: {
        allow_registration_web: true,
    },

    images: {
        default: {
            logo: `/logo.png`,
            logo_white: `/logoWhite.png`,
        }
    }

}

export default config